// @flow
import * as React from 'react';
import cn from 'classnames';

import { APP_CONFIG } from 'common/constants';
import { type EnhancedProps, withTransition } from 'client/components/common/HOCs/with-transition';
import { Responsive, Header } from 'client/components/common';
import FirstScreen from 'client/components/common/Screens/FirstScreen';
import { dataLayerEvents } from 'common/utils/gtag';

import HeroSlider from '../../common/HeroSlider';
import ItemPopUp from '../../common/ItemPopUp';

import * as css from './Intro.scss';

type Props = {|
	...EnhancedProps,
	className?: string,
	in: boolean,
	leads: Leads,
	setJsonLeads: any,
	settings: SettingsItemType,
|};

type State = {
	isShowAlreadyInSystemPopup: boolean,
};
class Intro extends React.PureComponent<Props, State> {
	transitionCompleteTimeout: TimeoutID;

	static defaultProps = {
		className: '',
	};

	componentDidMount() {
		const init = async () => {
			const response = await fetch(`https://${APP_CONFIG.cdn.dataStorage}/data/data-all.json`, {
				method: 'GET',
			});
			const result = await response.json();

			this.props.setJsonLeads(result.leads);
		};

		init();

		dataLayerEvents.mainPage();
	}

	componentDidUpdate(prevProps: Props) {
		if (this.props.in !== prevProps.in) {
			const { onTransitionComplete } = this.props;
			let duration = parseInt(this.props.in ? css.transitionIn : css.transitionOut, 10);

			if (!this.props.in) {
				duration = 0;
			}
			clearTimeout(this.transitionCompleteTimeout);
			this.transitionCompleteTimeout = setTimeout(onTransitionComplete, duration);
		}
	}

	render() {
		const { className, transitionState, leads, settings } = this.props;
		const isMobile = Responsive.isMatching(Responsive.MOBILE);
		return (
			<div className={cn(css.intro, css[transitionState], className)}>
				<Header isMobile={isMobile} />
				<HeroSlider />
				<FirstScreen
					leads={leads}
					isShowDelayMessage={settings.isShowDelayMessage || false}
					delayMessage={settings.delayMessage || ''}
				/>
				<ItemPopUp />
			</div>
		);
	}
}

export default withTransition(Intro);
